import { Prisma } from '@prisma/client';
import { useQuery } from '@tanstack/react-query';

import { FindSubscriptionAccessParams, SubscriptionAccessWithChildren } from '@app/domain-subscription-interfaces';
import { CommonFindResult } from '@app/infra-interfaces';
import { Axios } from '@app/web-components';

const SUBSCRIPTION_ACCESS_ALL_QUERY_KEY = 'SUBSCRIPTION_ACCESS_ALL_QUERY_KEY';

const SubscriptionAccessKeys = {
  all: [SUBSCRIPTION_ACCESS_ALL_QUERY_KEY] as const,
  lists: () => [...SubscriptionAccessKeys.all, 'list'] as const,
  list: (filters: object) => [...SubscriptionAccessKeys.lists(), filters] as const,
};

export const useFindSubscriptionAccess = (params: FindSubscriptionAccessParams, enabled = true) => {
  const axios = Axios.useAxiosApi();

  return useQuery<CommonFindResult<SubscriptionAccessWithChildren>>({
    queryKey: SubscriptionAccessKeys.list(params),
    queryFn: async () => {
      const { data } = await axios.post('/subscription-accesses/find', params);
      return data;
    },
    enabled,
  });
};

export const useAdvancedFindSubscriptionAccess = <T>(params: Prisma.SubscriptionAccessFindManyArgs) => {
  const axios = Axios.useAxiosApi();

  return useQuery<CommonFindResult<T>>({
    queryKey: SubscriptionAccessKeys.list(params),
    queryFn: async () => {
      const { data } = await axios.post('/subscription-accesses/advanced-find', params);
      return data;
    },
  });
};
